import { TextField } from '@material-ui/core';
import React, { useState } from 'react';
import UserUnit from '../../communicator/http/User';
import Loading from '../../helper/screens/Loading';
import { useForm } from "react-hook-form";
import Message from '../../elements/message';
import { translate } from '../../helper/multilingual';
import { Link } from 'react-router-dom';
import Logo from '../../assets/logo.png';


const PasswordForgot = () => {

    const [loading, setLoading] = useState(false);

    const { register, handleSubmit, formState: { errors } } = useForm();

    const userUnit = new UserUnit();

    const [errorMessageOpen, setErrorMessageOpen] = useState(false);
    const [errorMessageType, setErrorMessageType] = useState('error');
    const [errorMessageTitle, setErrorMessageTitle] = useState("");
    const [errorMessageBody, setErrorMessageBody] = useState("");
    const [errorMessageButtonText, setErrorMessageButtonText] = useState("OK");

    const doLogin = (data) => {

        setLoading(true);

        let cbSuccess = (res) => {
            setLoading(false);
            setErrorMessageTitle(translate('password_forgot_success_title'));
            setErrorMessageBody(translate('password_forgot_success_body'));
            setErrorMessageButtonText("OK");
            setErrorMessageType("success");
            setErrorMessageOpen(true);
        }

        let cbError = (err) => {
            setLoading(false);

            setErrorMessageTitle(translate('password_forgot_error_title'));
            setErrorMessageBody(translate('password_forgot_error_body'));
            setErrorMessageButtonText("OK");
            setErrorMessageType("error");
            setErrorMessageOpen(true);
        }

        userUnit.forgotPassword(data.email, cbSuccess, cbError);

    }

    return (
        <>
            <div className="login_wrapper">
                <img src={Logo} />
                <div className="login_container">
                    <Link to="/">{translate('back_to_login')}</Link>
                    <br/>
                    <h1>{translate('forgot_password')}</h1>
                    <br />
                    <form onSubmit={handleSubmit(doLogin)}>
                        <TextField
                            {...register('email', { required: true })}
                            error={errors.email}
                            id="standard-basic"
                            label={translate('email')}
                            type="email"
                        />
                        <input type="submit" style={{ width: '100%' }} className="button" value={translate('request_recoverylink')} />
                    </form>
                </div>

            </div>
            <Loading visible={loading} />
            <Message
                open={errorMessageOpen}
                type={errorMessageType}
                title={errorMessageTitle}
                body={errorMessageBody}
                buttonText={errorMessageButtonText}
                buttonAction={() => setErrorMessageOpen(false)}
            />
        </>
    );
}

export default PasswordForgot;